import React from 'react';

import { useRouter } from 'next/navigation';

import DecisionModal from '@repo/editor/src/components/DecisionModal/DecisionModal';

const VerifiedModal = (props) => {
  const router = useRouter();

  return (
    <DecisionModal
      firstButton={{
        label: 'Close',
        onClick: props.onClose,
      }}
      isOpen={props.isOpen}
      message="To upvote designs, you need to verify your Kittl account via email."
      secondButton={{
        label: 'Open Account Settings',
        width: '170px',
        onClick: () => router.push('/user/settings/account'),
      }}
      title="Your Account is not verified"
      onClose={props.onClose}
    />
  );
};

export default VerifiedModal;
